/** Reporting / self-service BI domain types. */

export type ChartType = 'bar' | 'line' | 'pie' | 'kpi' | 'table';
export type Aggregate = 'count' | 'sum' | 'avg' | 'min' | 'max';

export interface ReportColumn {
  name: string;
  data_type: string;
}

export interface ReportDataset {
  id: string;
  name: string;
  connector: string | null;
  source_type: string | null;
  row_count: number | null;
  columns: ReportColumn[];
}

export interface AggregateRow {
  label: string;
  value: number;
}

/** A single chart on the report canvas. `id` is a client-side uid. */
export interface WidgetConfig {
  id: string;
  title: string;
  /**
   * 'single' = one dataset, optionally grouped by a dimension.
   * 'compare' = the same measure aggregated across several datasets/tables,
   *             producing one data point per table. Older saved widgets have
   *             no `mode` and are treated as 'single'.
   */
  mode?: 'single' | 'compare';
  datasetId: string;
  datasetName: string;
  /** Compare mode only — the tables being compared. */
  datasetIds?: string[];
  datasetNames?: string[];
  chartType: ChartType;
  dimension: string | null;
  measure: string | null;
  aggregate: Aggregate;
  limit: number;
}

export const AGGREGATE_LABELS: Record<Aggregate, string> = {
  count: 'Count',
  sum: 'Sum',
  avg: 'Average',
  min: 'Minimum',
  max: 'Maximum',
};

/** Heuristic: does a schema data_type represent a number we can sum/average? */
export function isNumericType(dataType: string): boolean {
  return /int|num|dec|float|double|real|money|bigint|smallint/i.test(dataType);
}
